import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveValuators, GetValuators } from './index';

// Api's
import { valuatorApi } from '@/main/api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getValuatorsSaga(action: GetValuators) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      valuatorApi.getValuatorsDomain,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveValuators(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveValuators(null, true, resultError.messagesDataError));
    }
  }
}
